import React from "react";

function AdImage({ src, alt, className, ...rest }) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      {...rest}
    />
  );
}

export default AdImage;
